export const ONTOLOGY_GRAPH_MOCK_DISEASE_ID = '10004936';
export const ONTOLOGY_GRAPH_MOCK_DISEASE_CUI = 'C0004936';
export const ONTOLOGY_GRAPH_MOCK_ROOT_NODE_ID = 'C0004936';

/** Si es true, se muestra la fila "Ontology graph" en el detalle de la enfermedad. Definir por entorno (ej. true en dev/test, no definir o false en prod). Vite reemplaza process.env en build. */
export const isOntologyGraphFeatureVisible = process.env.REACT_APP_SHOW_ONTOLOGY_GRAPH === 'true';
export const isOntologyGraphEnabledForAllDiseases = process.env.REACT_APP_ONTOLOGY_GRAPH_ENABLED === 'true';

export function canShowOntologyGraph(diseaseId: string | number | undefined): boolean {
  const id = diseaseId != null ? String(diseaseId).trim() : '';
  if (!id) return false;
  if (isOntologyGraphEnabledForAllDiseases) return true;
  return id === ONTOLOGY_GRAPH_MOCK_DISEASE_ID || id === ONTOLOGY_GRAPH_MOCK_DISEASE_CUI;
}

export function canShowOntologyGraphOption(diseaseId: string | number | undefined): boolean {
  const id = diseaseId != null ? String(diseaseId) : '';
  return id.length > 0;
}

export function getOntologyRootNodeId(diseaseId: string | number | undefined): string {
  const id = diseaseId != null ? String(diseaseId).trim() : '';
  if (!id) return ONTOLOGY_GRAPH_MOCK_ROOT_NODE_ID;
  if (id === ONTOLOGY_GRAPH_MOCK_DISEASE_ID || id === ONTOLOGY_GRAPH_MOCK_DISEASE_CUI)
    return ONTOLOGY_GRAPH_MOCK_ROOT_NODE_ID;
  return id;
}
